var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_edit_1180632",
    transform: "translate(-18.75 -18.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M33.677,29.589v.023h0L32.167,34.1a.4.4,0,0,0,.511.511l4.475-1.491h.023a.4.4,0,0,0,.12-.081L47.555,22.78a1.617,1.617,0,0,0,0-2.263l-1.293-1.293h0a1.617,1.617,0,0,0-2.263,0L33.758,29.469a.4.4,0,0,0-.081.12Zm.543.912,2.056,2.056-3.088,1.028Zm7.721-8.083,2.412,2.412-7.327,7.337-2.412-2.412Zm.854-.854L45.2,23.976l-.281.281L42.51,21.845Zm1.778-1.778a.8.8,0,0,1,1.132,0l1.267,1.29a.8.8,0,0,1,0,1.135l-1.2,1.206L43.367,21Z",
    transform: "translate(-9.273 -0.028)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M38.35,27.074a.4.4,0,0,0-.4.4v9.18a1.28,1.28,0,0,1-1.28,1.279H20.82a1.28,1.28,0,0,1-1.28-1.279V20.8a1.28,1.28,0,0,1,1.28-1.279H30a.4.4,0,1,0,0-.8H20.82a2.07,2.07,0,0,0-2.07,2.069V36.651a2.07,2.07,0,0,0,2.07,2.069H36.68a2.07,2.07,0,0,0,2.07-2.069V27.474a.4.4,0,0,0-.4-.4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M53.638,40.184a.4.4,0,0,0,.572.016l3.372-3.175a.4.4,0,0,0-.553-.588l-3.376,3.175a.4.4,0,0,0-.016.572Z",
    transform: "translate(-23.679 -11.999)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.a753b12c.svg";
export { ForwardRef as ReactComponent };